import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  OverlayTrigger,
  Tooltip
} from 'react-bootstrap';

export class EmailButton extends Component {
  static propTypes = {
    onClick: PropTypes.func,
    toolTipText:PropTypes.string,
    style: PropTypes.object
  }

  toolTip() {
    return (
      <Tooltip className='in tooltip-siteone' id='tooltip-change-column'>
        <span>{this.props.toolTipText}</span>
      </Tooltip>
    );
  }

  render() {
    return <div className='email-export-btn-box'>
      <OverlayTrigger placement='bottom' overlay={this.toolTip()}>
        <button className='email-export-btn icon-excel-export-ic' onClick={this.props.onClick}>
          <i className='fa fa-envelope' style={this.props.style}/>
        </button>
      </OverlayTrigger>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/Work-Orders/Components/EmailButton.js